import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import ThirteenthSalaryEditorNavScreen from "../../screens/client/ThirteenthSalaryEditorNavScreen";
import { EarningType } from "../../__generated__/graphql";
import VStack from "../../ui_atoms/VStack";

const StoryComponent = (params: {
    has13thSalary: boolean;
    pay13thSalaryWithSalary: boolean;
    isMandatory: boolean;
    earningType: EarningType;
}) => (
    <VStack alignment="stretch" style={{ flex: 1 }}>
        {/* @ts-expect-error Stack Component need a complex navigation handler */}
        <ThirteenthSalaryEditorNavScreen route={{ params }} />
    </VStack>
);

const meta = {
    title: "CreateMission/13th salary editor",
    component: StoryComponent,
    argTypes: { earningType: { type: "symbol" } },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const MonthlyOptional: Story = {
    args: {
        has13thSalary: false,
        pay13thSalaryWithSalary: true,
        isMandatory: false,
        earningType: EarningType.Monthly,
    },
};

export const MonthlyMandatory13x: Story = {
    args: {
        has13thSalary: true,
        pay13thSalaryWithSalary: false,
        isMandatory: true,
        earningType: EarningType.Monthly,
    },
};

export const Hourly: Story = {
    args: {
        has13thSalary: true,
        pay13thSalaryWithSalary: true,
        isMandatory: false,
        earningType: EarningType.Hourly,
    },
};
